

import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Divider, Grid, Container,Card,CardMedia, CardActionArea, Button} from '@mui/material';
import Carousel from 'react-material-ui-carousel'
import DevicesRoundedIcon from '@mui/icons-material/DevicesRounded';
import EdgesensorHighRoundedIcon from '@mui/icons-material/EdgesensorHighRounded';
import ViewQuiltRoundedIcon from '@mui/icons-material/ViewQuiltRounded';

const items = [
    {
    icon: <ViewQuiltRoundedIcon />,
    title: 'Cirugía bucal',
    description:
        'This item could provide a snapshot of the most important metrics or data points related to the product.',
    imageLight: 'url("https://firebasestorage.googleapis.com/v0/b/hostingparademos.appspot.com/o/dentalsurbanner1.jpg?alt=media&token=6dda44c9-8637-4c97-b6a9-ccc3987c5979")',
    imageDark: 'url("https://firebasestorage.googleapis.com/v0/b/hostingparademos.appspot.com/o/dentalsurbanner1.jpg?alt=media&token=6dda44c9-8637-4c97-b6a9-ccc3987c5979")',
    image: "https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/landing%2Fcquirty_banner.svg?alt=media&token=b670bc52-dbdd-470c-9a92-7f44dfa355aa",
    },
    {
    icon: <EdgesensorHighRoundedIcon />,
    title: 'Ortodoncia',
    description:
        'This item could provide information about the mobile app version of the product.',
    imageLight: 'url("https://firebasestorage.googleapis.com/v0/b/hostingparademos.appspot.com/o/brackets.jpg?alt=media&token=b32c3c39-ce09-4d8e-a266-b4c039937430")',
    imageDark: 'url("https://firebasestorage.googleapis.com/v0/b/hostingparademos.appspot.com/o/brackets.jpg?alt=media&token=b32c3c39-ce09-4d8e-a266-b4c039937430")',
    image: "https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/landing%2Fcquirty_banner.svg?alt=media&token=b670bc52-dbdd-470c-9a92-7f44dfa355aa",
    },
    {
    icon: <DevicesRoundedIcon />,
    title: 'Odontopediatría',
    description:
        'This item could let users know the product is available on all platforms, such as web, mobile, and desktop.',
    imageLight: 'url("/static/images/templates/templates-images/devices-light.png")',
    imageDark: 'url("/static/images/templates/templates-images/devices-dark.png")',
    image: "https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/landing%2Fcquirty_banner.svg?alt=media&token=b670bc52-dbdd-470c-9a92-7f44dfa355aa",

    },

];


export default function News() {

  return (
    <Container id="news"  maxWidth = {"xl"}  component='main' >
      <Divider sx={{my:8}}></Divider>
      <Typography component="p" variant="subtitle2" align="center" color="text.secondary">
          News
      </Typography>
      <Grid container columns={12} sx={{pt:8,pb:8}} spacing={2} alignItems="center" >  
      <Grid item xs={12} md ={6} sm={6} align="center" alignContent={"center"} alignItems={"center"}>  
               <Button variant='contained-primary'>Leer mas</Button>
          </Grid> 
          <Grid item xs={12} md ={6} sm={6} align="center" >  
            <Typography component="p"  variant="h4" align="right"  color="primsary" >
              Enterate de todas nuestras nuevas actualizaciones y servicios
            </Typography>
            <Typography sx={{pt:8}} component="p"  variant="body1" align="right"  color="text.secondary" >
              Somos la plataforma que está transformando la experiencia de moverse en el mundo, integrando cualquier nodo de movilidad para hacerlo más seguro, rápido y vanguardista. Únete a esta gran revolución digital.
            </Typography>
          </Grid>  
       
      </Grid>
      <Grid container columns={12} sx={{pt:8,pb:8}} spacing={2}>  
          <Grid item xs={12} md ={12} sm={12} align="center" >  
              <Carousel fullHeightHover={false} animation="slide" >
                  {
                      items.map( (item, i) => <Card style={{}}> 
                      <CardActionArea>
                          <CardMedia
                              component="img"
                              height="400"
                              image= {item.image}
                              alt="banner"
                              />
                          
                      </CardActionArea>
                  </Card> )
                  }
              </Carousel>
          </Grid>     
      </Grid>
     
    </Container>
  );
}